import React from 'react'

const AddPickComment = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M14.9 27.6V2.5l4.4 4.4c.1.1.3.2.5.2.4 0 .7-.3.7-.7 0-.2-.1-.4-.2-.5L14.6.2c-.3-.3-.7-.3-1 0L8 5.9c-.3.3-.3.7 0 1 .3.3.7.3 1 0l4.4-4.4v25.1c0 .4.3.7.7.7.5 0 .8-.3.8-.7z" />
  </svg>
)

export default AddPickComment
